import { Utils } from "./utils";

export function logInterceptor() {
  if (import.meta.env.MODE === "development") return;

  console.logOg = console.log; // keeping original function under new name

  console.log = function () {
    // converting arguments object to array
    const args = Array.from(arguments);
    // calling original log function with args

    console.logOg.apply(this, args);

    if (typeof args[0] === "string" && args[0]?.includes("SPLOG")) {
      const log = parseSPLogToFlutterLog(args);
      Utils.pushLog(log);
    }
  };

  console.errorOg = console.error;
  console.error = function () {
    // extract message from arguments
    const error = arguments[0];
    const errorA = [error.message, error.stack, error.name, error.cause];
    // converting arguments object to array
    const args = Array.from(arguments);

    // calling original log function with args
    console.errorOg.apply(this, args);

    Utils.pushLog({
      tags: ["ERROR"],
      message: errorA[0],
      extraArgs: errorA.slice(1),
      timeStamp: Date.now(),
    });
  };
}

function parseSPLogToFlutterLog(logArgs: any[]) {
  const timeStamp = new Date().getTime();
  const tags = [];
  if (logArgs[2] && logArgs[2].length > 0) {
    tags.push(...logArgs[2]);
  }
  tags.push(tagFromlevel(logArgs[1]));
  const message = logArgs[4];
  // take all args after 5th
  const extraArgs = logArgs.slice(5);
  return { timeStamp, tags, message, extraArgs };
}

function tagFromlevel(level: any) {
  switch (level) {
    case 0:
    case 1:
    case 2:
    case 3: {
      return "DEBUG";
    }
    case 4: {
      return "WARNING";
    }
    case 5: {
      return "ERROR";
    }
    default: {
      return "ERROR";
    }
  }
}
